/**
 * defa.collections.Units
 * A Collection of Units with custom filters.
 * @version 1.2.0
 */
import Unit from 'scripts/defa/units/model-unit';

const Units = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model     : Unit,
	comparator: function ( model ) {
		return model.get( 'alias' );
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new Units collection filtered by an array of ids.
	 * @param  {array}      ids  An array of ids to filter the collection by.
	 * @return {Collection}      The filtered UnitCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( unit ) {
			return _.contains( ids, unit.get( 'id' ) );
		} );
		
		return new Units( array );
	},
	
	/**
	 * Gets bluetooth units.
	 * @return {Collection}  All bluetooth units.
	 */
	getBluetoothUnits: function () {
		let array = this.filter( function ( unit ) {
			return ( 'BLUETOOTH' === unit.get( 'family' ) );
		} );
		
		return new Units( array );
	},
} );


export default Units;